<template>
    <page>
        <module :title="title">
            <c-form ref="form">
                <c-form ref="editForm">
		                <c-form-column>
                            <c-form-item type="input" label="订购服务热线" name="sales_phone_number" required></c-form-item>
                            <c-form-item type="input" label="售后支持热线" name="after_sales_phone_number" required></c-form-item>
                            <c-form-item type="input" label="客服电话" name="customer_service_phone_number" required></c-form-item>
                            <c-form-item type="input" label="联系邮箱" name="email" required></c-form-item>
                            <c-form-item type="textarea" label="技术支持联系方式" name="technical_support_contact" required></c-form-item>
                            <c-form-item type="input" label="HR联系邮箱" name="hr_email" required></c-form-item>
                            <c-form-item type="input" label="联系地址" name="address" required></c-form-item>
                            <c-form-item type="image" label="公众号二维码" name="image1" required file-word="建议尺寸：300×300px"></c-form-item>
                            <c-form-item type="image" label="视频号二维码" name="image2" required file-word="建议尺寸：300×300px"></c-form-item>
                            <c-form-item type="image" label="技术研讨群码" name="image3" required file-word="建议尺寸：300×300px"></c-form-item>
		                </c-form-column>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button  size="m" @click="save()">保存</c-button>
            </template>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_system_image',

        components: {
        },

        props: {
            languageType: Number        //2=英文  1=中文
        },
        computed:{

        },
        watch:{
            languageType(){
                this.title = (this.languageType==1?'中文':'英文')+'首页联系方式'
            }
        },

        data() {
            return {
                title:'首页联系方式'
            }
        },

        mounted() {
	        this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: this.languageType==2?'/website/system_en/contact/detail':'/website/system/contact/detail',
                    data: {},
                    loading: true,
                    success: data => {
	                    if (data){
		                    var formObj = JSON.parse(data);
		                    this.$refs.editForm.set(formObj);
	                    }
                    }
                });
            },

            save() {
                this.$refs.editForm.submit({
	                url: this.languageType==2?'/website/system_en/contact/edit':'/website/system/contact/edit',
                    rule: {
                        sales_phone_number:'请输入订购服务热线',
                        after_sales_phone_number:'请输入售后支持热线',
                        customer_service_phone_number:'请输入客服电话',
                        email:'请输入联系邮箱',
                        technical_support_contact:'技术支持联系方式',
                        address:'请输入联系地址',
                        image1:'请上传公众号二维码',
                        image2:'请上传视频号二维码',
                        image3:'请上传技术研讨群码'
                    },
                    dataFormatter: data => {
						var submitObj = {};
	                    submitObj.control_configure = JSON.stringify(data)
                        return submitObj;
                    },
                    success: () => {
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                    }
                });
            },
        }
    }
</script>

<style lang="stylus" scoped>
  .invoice-list {
    .item {
      box-sizing: border-box;
      width: 360px;
      height: 360px;
      padding: 10px 15px;
      margin-right: 26px;
      margin-bottom: 26px;
      background: #F9F9F9;

      p {
        padding: 5px 0;
        line-height: 20px;
        font-size: 13px;
        color: #333;
      }

      .handle {
        margin-top: 20px;
        text-align: right;

        a {
          margin-left: 15px;
          font-size: 16px;
          color: #666;
        }
      }
    }

    .add {
      box-sizing: border-box;
      width: 360px;
      height: 360px;
      border: 1px dashed #ddd;
      font-size: 50px;
      color: #ccc;
      cursor: pointer;

      &:hover {
        theme-border(main);
        theme-color(main);
      }
    }
  }
</style>